// extracted by mini-css-extract-plugin
export default {"container":"Tj-z","bubbleNav":"Uj-z","graphic":"Vj-z","contact":"Wj-z"};